import auth from "../../middlewares/auth";
export const holidayLectureRoute = [
  {
    path: '/lecture/holiday-lecture/systematic-mathematics/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/systematic_mathematics/List'),
    name: 'holiday_systematic_mathematics_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/systematic-mathematics/create',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/systematic_mathematics/Form'),
    name: 'holiday_systematic_mathematics_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/systematic-mathematics/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/systematic_mathematics/Form'),
    name: 'holiday_systematic_mathematics_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/parochial-mathematics/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/parochial_mathematics/List'),
    name: 'holiday_parochial_mathematics_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/parochial-mathematics/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/parochial_mathematics/Form'),
    name: 'holiday_parochial_mathematics_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/parochial-mathematics/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/parochial_mathematics/Form'),
    name: 'holiday_parochial_mathematics_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/convergence-mathematics/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/convergence_mathematics/List'),
    name: 'holiday_convergence_mathematics_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/convergence-mathematics/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/convergence_mathematics/Form'),
    name: 'holiday_convergence_mathematics_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/convergence-mathematics/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/convergence_mathematics/Form'),
    name: 'holiday_convergence_mathematics_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/parent-special-lecture/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/parent_special_lecture/List'),
    name: 'holiday_parent_special_lecture_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/parent-special-lecture/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/parent_special_lecture/Form'),
    name: 'holiday_parent_special_lecture_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/parent-special-lecture/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/parent_special_lecture/Form'),
    name: 'holiday_parent_special_lecture_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/enjoy-learning/list',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/enjoy_learning/List'),
    name: 'holiday_enjoy_learning_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/enjoy-learning/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/enjoy_learning/Form'),
    name: 'holiday_enjoy_learning_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/lecture/holiday-lecture/enjoy-learning/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/holiday_lecture/enjoy_learning/Form'),
    name: 'holiday_enjoy_learning_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/special-lecture-list/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/special_lecture/SpecialLectureList'),
    name: 'special_lecture_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/special-lecture-list/:id/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/special_lecture/SpecialLectureAdd'),
    name: 'special_lecture_create',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/special-lecture-list/:id/edit/:lecture_id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/special_lecture/SpecialLectureAdd'),
    name: 'special_lecture_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  },
];